import {
  getVisitDayWeekMonth,
  getVisitCount,
  getVisitCountMonth,
  getVisitPlatform,
  getVisitModule,
  getVisitRole,
  getCountryDis,
  getTypeDis,
  getDepartmentDis,
  getNewUserData,
  getNewUserChartData,
  getActiveUserData,
  getActiveUserChartData,
  getActiveDayData,
  getActiveDayChartData,
  getMostlyVisitedModule,
  getHomePageClick,
  getSearchPageClick,
  getOnlineTimeData,
  getOnlineTimeChartData,
  getVisitedPageData,
  getVisitedPageChartData,
  getRetentionData,
  getCompany,
  getExportCount,
  getActiveCount,
  getRegisterCount,
  getActiveAvgCount,
  getAvgOnlineTime,
  getAvgVisitedPage
} from '@/axios/api/userBehavior'

const UPDATE_VISIT_DAY = 'UPDATE_VISIT_DAY'
const UPDATE_VISIT_COUNT = 'UPDATE_VISIT_COUNT'
const UPDATE_VISIT_COUNT_MONTH = 'UPDATE_VISIT_COUNT_MONTH'
const UPDATE_VISIT_PLATFORM = 'UPDATE_VISIT_PLATFORM'
const UPDATE_VISIT_MODULE = 'UPDATE_VISIT_MODULE'
const UPDATE_VISIT_ROLE = 'UPDATE_VISIT_ROLE'
const UPDATE_USER_TYPE = 'UPDATE_USER_TYPE'
const UPDATE_COUNTRY = 'UPDATE_COUNTRY'
const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE'
const UPDATE_COUNTRY_DIS = 'UPDATE_COUNTRY_DIS'
const UPDATE_TYPE_DIS = 'UPDATE_TYPE_DIS'
const UPDATE_DEPARTMENT_DIS = 'UPDATE_DEPARTMENT_DIS'
const UPDATE_NEW_USER_DATA = 'UPDATE_NEW_USER_DATA'
const UPDATE_NEW_USER_CHART_DATA = 'UPDATE_NEW_USER_CHART_DATA'
const UPDATE_ACTIVE_USER_DATA = 'UPDATE_ACTIVE_USER_DATA'
const UPDATE_ACTIVE_USER_CHART_DATA = 'UPDATE_ACTIVE_USER_CHART_DATA'
const UPDATE_ACTIVE_DAY_DATA = 'UPDATE_ACTIVE_DAY_DATA'
const UPDATE_ACTIVE_DAY_CHART_DATA = 'UPDATE_ACTIVE_DAY_CHART_DATA'
const UPDATE_MOSTLY_MODULE = 'UPDATE_MOSTLY_MODULE'
const UPDATE_MOSTLY_PAGE = 'UPDATE_MOSTLY_PAGE'
const UPDATE_ONLINE_TIME_DATA = 'UPDATE_ONLINE_TIME_DATA'
const UPDATE_ONLINE_TIME_CHART_DATA = 'UPDATE_ONLINE_TIME_CHART_DATA'
const UPDATE_VISITED_PAGE_DATA = 'UPDATE_VISITED_PAGE_DATA'
const UPDATE_VISITED_PAGE_CHART_DATA = 'UPDATE_VISITED_PAGE_CHART_DATA'
const UPDATE_HOME_PAGE_CLICK = 'UPDATE_HOME_PAGE_CLICK'
const UPDATE_SEARCH_PAGE_CLICK = 'UPDATE_SEARCH_PAGE_CLICK'
const UPDATE_RETENTION = 'UPDATE_RETENTION'
const UPDATE_COMPANY = 'UPDATE_COMPANY'
const UPDATE_COMPANY_TEXT = 'UPDATE_COMPANY_TEXT'
const UPDATE_DATA_STATUS = 'UPDATE_DATA_STATUS'
const UPDATE_ACTIVE_COUNT = 'UPDATE_ACTIVE_COUNT'
const UPDATE_REGISTER_COUNT = 'UPDATE_REGISTER_COUNT'
const UPDATE_ACTIVE_AVG_COUNT = 'UPDATE_ACTIVE_AVG_COUNT'
const UPDATE_AVG_ONLINE_TIME = 'UPDATE_AVG_ONLINE_TIME'
const UPDATE_AVG_VISITED_PAGE = 'UPDATE_AVG_VISITED_PAGE'

const state = {
  visitDay: {},
  visitCount: [],
  visitCountMonth: [],
  visitPlatform: {},
  visitModule: [],
  visitRole: [],
  userType: '',
  country: '',
  userRole: '',
  countryDis: [],
  typeDis: [],
  departmentDis: [],
  newUserData: {},
  newUserChartData: [],
  activeUserData: {},
  activeUserChartData: [],
  activeDayData: {},
  activeDayChartData: [],
  mostlyModule: [],
  mostlyPage: [],
  homePageClick: [],
  searchPageClick: [],
  onlineTimeData: [],
  onlineTimeChartData: [],
  visitedPageData: [],
  visitedPageChartData: [],
  retention: [],
  company: [],
  companyText: '',
  dataStatus: 'All',
  activeCount: '',
  registerCount: '',
  activeAvgCount: '',
  avgOnlineTime: '',
  avgVisitedPage: ''
}

const getters = {
  visitDay: state => state.visitDay,
  visitCount: state => state.visitCount,
  visitCountMonth: state => state.visitCountMonth,
  visitPlatform: state => state.visitPlatform,
  visitModule: state => state.visitModule,
  visitRole: state => state.visitRole,
  userType: state => state.userType,
  country: state => state.country,
  userRole: state => state.userRole,
  countryDis: state => {
    let sum = 0
    state.countryDis.forEach(v => {
      sum += v.countNum
    })
    return state.countryDis.map(v => {
      return {
        ...v,
        rate: (v.countNum * 100 / sum).toFixed(2) + '%'
      }
    })
  },
  typeDis: state => {
    let sum = 0
    state.typeDis.forEach(v => {
      sum += v.countNum
    })
    return state.typeDis.map(v => {
      return {
        ...v,
        rate: (v.countNum * 100 / sum).toFixed(2) + '%'
      }
    })
  },
  departmentDis: state => {
    let sum = 0
    state.departmentDis.forEach(v => {
      sum += v.countNum
    })
    return state.departmentDis.map(v => {
      return {
        ...v,
        rate: (v.countNum * 100 / sum).toFixed(2) + '%'
      }
    })
  },
  newUserData: state => state.newUserData,
  newUserChartData: state => state.newUserChartData.map(v => {
    return {
      ...v,
      name: v.register_date,
      value: v.registerCount
    }
  }),
  activeUserData: state => state.activeUserData,
  activeUserChartData: state => state.activeUserChartData.map(v => {
    return {
      ...v,
      name: v.date,
      value: v.userCount
    }
  }),
  activeDayData: state => state.activeDayData,
  activeDayChartData: state => state.activeDayChartData.map(v => {
    let unit
    if (v.dayCount === '1') {
      unit = window.$lang('userBehavior.day')
    } else if (v.dayCount === '26') {
      unit = window.$lang('userBehavior.day') + '+'
    } else {
      unit = window.$lang('userBehavior.days')
    }
    return {
      ...v,
      name: v.dayCount + unit,
      value: v.userCount
    }
  }),
  mostlyModule: state => state.mostlyModule.map(v => {
    return {
      ...v,
      name: v.moduleName,
      value: v.count,
      id: v.metrics
    }
  }),
  mostlyPage: state => state.mostlyPage.map(v => {
    return {
      ...v,
      value: v.count,
      id: v.metrics
    }
  }),
  homePageClick: state => state.homePageClick,
  searchPageClick: state => state.searchPageClick,
  onlineTimeData: state => state.onlineTimeData,
  onlineTimeChartData: state => state.onlineTimeChartData.map(v => {
    return {
      ...v,
      name: v.viewTime,
      value: v.userCount
    }
  }),
  visitedPageData: state => state.visitedPageData,
  visitedPageChartData: state => state.visitedPageChartData.map(v => {
    return {
      ...v,
      name: v.pageCount,
      value: v.userCount
    }
  }),
  retention: state => state.retention.map(v => {
    return {
      ...v,
      '1dayRate': v['1dayRate'] || v['1dayRate'] === 0 ? v['1dayRate'] + '%' : '',
      '2dayRate': v['2dayRate'] || v['2dayRate'] === 0 ? v['2dayRate'] + '%' : '',
      '3dayRate': v['3dayRate'] || v['3dayRate'] === 0 ? v['3dayRate'] + '%' : '',
      '4dayRate': v['4dayRate'] || v['4dayRate'] === 0 ? v['4dayRate'] + '%' : '',
      '5dayRate': v['5dayRate'] || v['5dayRate'] === 0 ? v['5dayRate'] + '%' : '',
      '6dayRate': v['6dayRate'] || v['6dayRate'] === 0 ? v['6dayRate'] + '%' : '',
      '30dayRate': v['30dayRate'] || v['30dayRate'] === 0 ? v['30dayRate'] + '%' : '',
      '2WeekUserRate': v['2WeekUserRate'] || v['2WeekUserRate'] === 0 ? v['2WeekUserRate'] + '%' : '',
      '5WeekUserRate': v['5WeekUserRate'] || v['5WeekUserRate'] === 0 ? v['5WeekUserRate'] + '%' : '',
      '10WeekUserRate': v['10WeekUserRate'] || v['10WeekUserRate'] === 0 ? v['10WeekUserRate'] + '%' : '',
      '2MonthUserRate': v['2MonthUserRate'] || v['2MonthUserRate'] === 0 ? v['2MonthUserRate'] + '%' : '',
      '3MonthUserRate': v['3MonthUserRate'] || v['3MonthUserRate'] === 0 ? v['3MonthUserRate'] + '%' : '',
      '4MonthUserRate': v['4MonthUserRate'] || v['4MonthUserRate'] === 0 ? v['4MonthUserRate'] + '%' : ''
    }
  }),
  company: state => state.company.map(v => {
    return {
      ...v,
      showName: v.name.length > 20 ? v.name.slice(0, 20) + '...' : v.name
    }
  }),
  companyText: state => state.companyText,
  dataStatus: state => state.dataStatus,
  activeCount: state => state.activeCount,
  registerCount: state => state.registerCount,
  activeAvgCount: state => state.activeAvgCount,
  avgOnlineTime: state => state.avgOnlineTime,
  avgVisitedPage: state => state.avgVisitedPage
}

const mutations = {
  [UPDATE_VISIT_DAY] (state, visitDay) {
    state.visitDay = visitDay
  },
  [UPDATE_VISIT_COUNT] (state, visitCount) {
    state.visitCount = visitCount
  },
  [UPDATE_VISIT_COUNT_MONTH] (state, visitCountMonth) {
    state.visitCountMonth = visitCountMonth
  },
  [UPDATE_VISIT_PLATFORM] (state, visitPlatform) {
    state.visitPlatform = visitPlatform
  },
  [UPDATE_VISIT_MODULE] (state, visitModule) {
    state.visitModule = visitModule
  },
  [UPDATE_VISIT_ROLE] (state, visitRole) {
    state.visitRole = visitRole
  },
  [UPDATE_USER_TYPE] (state, userType) {
    state.userType = userType
  },
  [UPDATE_COUNTRY] (state, country) {
    state.country = country
  },
  [UPDATE_USER_ROLE] (state, userRole) {
    state.userRole = userRole
  },
  [UPDATE_COUNTRY_DIS] (state, countryDis) {
    state.countryDis = countryDis
  },
  [UPDATE_TYPE_DIS] (state, typeDis) {
    state.typeDis = typeDis
  },
  [UPDATE_DEPARTMENT_DIS] (state, departmentDis) {
    state.departmentDis = departmentDis
  },
  [UPDATE_NEW_USER_DATA] (state, newUserData) {
    state.newUserData = newUserData
  },
  [UPDATE_NEW_USER_CHART_DATA] (state, newUserChartData) {
    state.newUserChartData = newUserChartData
  },
  [UPDATE_ACTIVE_USER_DATA] (state, activeUserData) {
    state.activeUserData = activeUserData
  },
  [UPDATE_ACTIVE_USER_CHART_DATA] (state, activeUserChartData) {
    state.activeUserChartData = activeUserChartData
  },
  [UPDATE_ACTIVE_DAY_DATA] (state, activeDayData) {
    state.activeDayData = activeDayData
  },
  [UPDATE_ACTIVE_DAY_CHART_DATA] (state, activeDayChartData) {
    state.activeDayChartData = activeDayChartData
  },
  [UPDATE_MOSTLY_MODULE] (state, mostlyModule) {
    state.mostlyModule = mostlyModule
  },
  [UPDATE_MOSTLY_PAGE] (state, mostlyPage) {
    state.mostlyPage = mostlyPage
  },
  [UPDATE_ONLINE_TIME_DATA] (state, onlineTimeData) {
    state.onlineTimeData = onlineTimeData
  },
  [UPDATE_ONLINE_TIME_CHART_DATA] (state, onlineTimeChartData) {
    state.onlineTimeChartData = onlineTimeChartData
  },
  [UPDATE_VISITED_PAGE_DATA] (state, visitedPageData) {
    state.visitedPageData = visitedPageData
  },
  [UPDATE_VISITED_PAGE_CHART_DATA] (state, visitedPageChartData) {
    state.visitedPageChartData = visitedPageChartData
  },
  [UPDATE_HOME_PAGE_CLICK] (state, homePageClick) {
    state.homePageClick = homePageClick
  },
  [UPDATE_SEARCH_PAGE_CLICK] (state, searchPageClick) {
    state.searchPageClick = searchPageClick
  },
  [UPDATE_RETENTION] (state, retention) {
    state.retention = retention
  },
  [UPDATE_COMPANY] (state, company) {
    state.company = company
  },
  [UPDATE_COMPANY_TEXT] (state, companyText) {
    state.companyText = companyText
  },
  [UPDATE_DATA_STATUS] (state, dataStatus) {
    state.dataStatus = dataStatus
  },
  [UPDATE_ACTIVE_COUNT] (state, activeCount) {
    state.activeCount = activeCount
  },
  [UPDATE_REGISTER_COUNT] (state, registerCount) {
    state.registerCount = registerCount
  },
  [UPDATE_ACTIVE_AVG_COUNT] (state, activeAvgCount) {
    state.activeAvgCount = activeAvgCount
  },
  [UPDATE_AVG_ONLINE_TIME] (state, avgOnlineTime) {
    state.avgOnlineTime = avgOnlineTime
  },
  [UPDATE_AVG_VISITED_PAGE] (state, avgVisitedPage) {
    state.avgVisitedPage = avgVisitedPage
  }
}

const actions = {
  async getVisitDayWeekMonthApi ({commit}, params) {
    try {
      let { data: res } = await getVisitDayWeekMonth(params)
      commit(UPDATE_VISIT_DAY, res)
    } catch (e) {}
  },
  async getVisitCountApi ({commit}, params) {
    try {
      let { data: res } = await getVisitCount(params)
      commit(UPDATE_VISIT_COUNT, res || [])
    } catch (e) {
      commit(UPDATE_VISIT_COUNT, [])
    }
  },
  async getVisitCountMonthApi ({commit}, params) {
    try {
      let { data: res } = await getVisitCountMonth(params)
      commit(UPDATE_VISIT_COUNT_MONTH, res || [])
    } catch (e) {
      commit(UPDATE_VISIT_COUNT_MONTH, [])
    }
  },
  async getVisitPlatformApi ({commit}, params) {
    try {
      let { data: res } = await getVisitPlatform(params)
      commit(UPDATE_VISIT_PLATFORM, res || {})
    } catch (e) {
      commit(UPDATE_VISIT_PLATFORM, {})
    }
  },
  async getVisitModuleApi ({commit}, params) {
    try {
      let { data: res } = await getVisitModule(params)
      commit(UPDATE_VISIT_MODULE, res)
    } catch (e) {}
  },
  async getVisitRoleApi ({commit}, params) {
    try {
      let { data: res } = await getVisitRole(params)
      commit(UPDATE_VISIT_ROLE, res || [])
    } catch (e) {
      commit(UPDATE_VISIT_ROLE, [])
    }
  },
  async getCountryDisApi ({commit}, params) {
    try {
      const { data: res } = await getCountryDis(params)
      commit(UPDATE_COUNTRY_DIS, res || [])
    } catch (e) {
      commit(UPDATE_COUNTRY_DIS, [])
    }
  },
  async getTypeDisApi ({commit}, params) {
    try {
      const { data: res } = await getTypeDis(params)
      commit(UPDATE_TYPE_DIS, res || [])
    } catch (e) {
      commit(UPDATE_TYPE_DIS, [])
    }
  },
  async getDepartmentDisApi ({commit}, params) {
    try {
      const { data: res } = await getDepartmentDis(params)
      commit(UPDATE_DEPARTMENT_DIS, res || [])
    } catch (e) {
      commit(UPDATE_DEPARTMENT_DIS, [])
    }
  },
  async getNewUserDataApi ({commit}, params) {
    try {
      const { data: res } = await getNewUserData(params)
      commit(UPDATE_NEW_USER_DATA, res || {})
    } catch (e) {
      commit(UPDATE_NEW_USER_DATA, {})
    }
  },
  async getNewUserChartDataApi ({commit}, params) {
    try {
      const { data: res } = await getNewUserChartData(params)
      commit(UPDATE_NEW_USER_CHART_DATA, res || [])
    } catch (e) {
      commit(UPDATE_NEW_USER_CHART_DATA, [])
    }
  },
  async getActiveUserDataApi ({commit}, params) {
    try {
      const { data: res } = await getActiveUserData(params)
      commit(UPDATE_ACTIVE_USER_DATA, res || {})
    } catch (e) {
      commit(UPDATE_ACTIVE_USER_DATA, {})
    }
  },
  async getActiveUserChartDataApi ({commit}, params) {
    try {
      const { data: res } = await getActiveUserChartData(params)
      commit(UPDATE_ACTIVE_USER_CHART_DATA, res || [])
    } catch (e) {
      commit(UPDATE_ACTIVE_USER_CHART_DATA, [])
    }
  },
  async getActiveDayDataApi ({commit}, params) {
    try {
      const { data: res } = await getActiveDayData(params)
      commit(UPDATE_ACTIVE_DAY_DATA, res || {})
    } catch (e) {
      commit(UPDATE_ACTIVE_DAY_DATA, {})
    }
  },
  async getActiveDayChartDataApi ({commit}, params) {
    try {
      const { data: res } = await getActiveDayChartData(params)
      commit(UPDATE_ACTIVE_DAY_CHART_DATA, res || [])
    } catch (e) {
      commit(UPDATE_ACTIVE_DAY_CHART_DATA, [])
    }
  },
  async getMostlyDataApi ({commit}, params) {
    try {
      const { data: res } = await getMostlyVisitedModule(params)
      commit(UPDATE_MOSTLY_MODULE, res.moduleList || [])
    } catch (e) {
      commit(UPDATE_MOSTLY_MODULE, [])
    }
  },
  async getMostlyPagesApi ({commit}, params) {
    try {
      const { data: res } = await getMostlyVisitedModule(params)
      commit(UPDATE_MOSTLY_PAGE, res.topPagesList || [])
    } catch (e) {
      commit(UPDATE_MOSTLY_PAGE, [])
    }
  },
  async getOnlineTimeDataApi ({commit}, params) {
    try {
      const { data: res } = await getOnlineTimeData(params)
      commit(UPDATE_ONLINE_TIME_DATA, res || {})
    } catch (e) {
      commit(UPDATE_ONLINE_TIME_DATA, {})
    }
  },
  async getOnlineTimeChartDataApi ({commit}, params) {
    try {
      const { data: res } = await getOnlineTimeChartData(params)
      commit(UPDATE_ONLINE_TIME_CHART_DATA, res || [])
    } catch (e) {
      commit(UPDATE_ONLINE_TIME_CHART_DATA, [])
    }
  },
  async getVisitedPageDataApi ({commit}, params) {
    try {
      const { data: res } = await getVisitedPageData(params)
      commit(UPDATE_VISITED_PAGE_DATA, res || {})
    } catch (e) {
      commit(UPDATE_VISITED_PAGE_DATA, {})
    }
  },
  async getVisitedPageChartDataApi ({commit}, params) {
    try {
      const { data: res } = await getVisitedPageChartData(params)
      commit(UPDATE_VISITED_PAGE_CHART_DATA, res || [])
    } catch (e) {
      commit(UPDATE_VISITED_PAGE_CHART_DATA, [])
    }
  },
  async getHomePageClickApi ({commit}, params) {
    try {
      const { data: res } = await getHomePageClick(params)
      commit(UPDATE_HOME_PAGE_CLICK, res || [])
    } catch (e) {
      commit(UPDATE_HOME_PAGE_CLICK, [])
    }
  },
  async getSearchPageClickApi ({commit}, params) {
    try {
      const { data: res } = await getSearchPageClick(params)
      commit(UPDATE_SEARCH_PAGE_CLICK, res || [])
    } catch (e) {
      commit(UPDATE_SEARCH_PAGE_CLICK, [])
    }
  },
  async getRetentionDataApi ({commit}, params) {
    try {
      const { data: res } = await getRetentionData(params)
      commit(UPDATE_RETENTION, res || [])
    } catch (e) {
      commit(UPDATE_RETENTION, [])
    }
  },
  async getCompanyApi ({commit}, params) {
    try {
      const { data: res } = await getCompany(params)
      commit(UPDATE_COMPANY, res || [])
    } catch (e) {
      commit(UPDATE_COMPANY, [])
    }
  },
  async getExportCountApi ({ commit }, params) {
    try {
      const { data: res } = await getExportCount(params)
      return res
    } catch (e) {
      return 0
    }
  },
  async getActiveCountApi ({commit}, params) {
    try {
      const { data: res } = await getActiveCount(params)
      commit(UPDATE_ACTIVE_COUNT, res || 0)
    } catch (e) {
      commit(UPDATE_ACTIVE_COUNT, '')
    }
  },
  async getRegisterCountApi ({commit}, params) {
    try {
      const { data: res } = await getRegisterCount(params)
      commit(UPDATE_REGISTER_COUNT, res || 0)
    } catch (e) {
      commit(UPDATE_REGISTER_COUNT, '')
    }
  },
  async getActiveAvgCountApi ({commit}, params) {
    try {
      const { data: res } = await getActiveAvgCount(params)
      commit(UPDATE_ACTIVE_AVG_COUNT, res.sectionAvgCount || 0)
    } catch (e) {
      commit(UPDATE_ACTIVE_AVG_COUNT, '')
    }
  },
  async getAvgOnlineTimeApi ({commit}, params) {
    try {
      const { data: res } = await getAvgOnlineTime(params)
      commit(UPDATE_AVG_ONLINE_TIME, res.onlineTime || 0)
    } catch (e) {
      commit(UPDATE_AVG_ONLINE_TIME, '')
    }
  },
  async getAvgVisitedPageApi ({commit}, params) {
    try {
      const { data: res } = await getAvgVisitedPage(params)
      commit(UPDATE_AVG_VISITED_PAGE, res.avgPageCount || 0)
    } catch (e) {
      commit(UPDATE_AVG_VISITED_PAGE, '')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/userBehavior.js